import AgencyHelper from 'features/Agency/agencyHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import CustomCard from 'general/components/Others/CustomCard';
import FileUploadView from 'general/components/quybka/Uploads/FileUploadView';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ShowMoreText from 'react-show-more-text';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import VoucherListView from 'features/ManageVoucherPartner/Voucher/components/VoucherListView';
import DialogVoucherBatchAddView from '../DialogVoucherBatchAddView';

function VoucherBatchDetailView(props) {
  // ---- params ----
  const { t } = useTranslation();
  const router = useRouter();
  const voucherBatchId = router.query?.voucherBatchId;
  const { user, permissionList } = useSelector((state) => state.auth);
  const [voucherBatchDetail, setVoucherBatchDetail] = useState(null);

  const adminRole =
    user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

  useEffect(() => {
    getVoucherBatchDetail(voucherBatchId);
  }, [voucherBatchId]);

  const getVoucherBatchDetail = (id) => {
    AgencyHelper.API.requestGetVoucherBatchDetail(id).then((data) => {
      if (Object.keys(data)?.length > 0) {
        setVoucherBatchDetail({ ...voucherBatchDetail, ...data });
      } else {
        router.navigate(-1);
      }
    });
  };


  // ---- methods ----
  const handleViewFiles = (files) => {
    AppCustomDialogHelper.show(
      'Tệp đính kèm',
      <FileUploadView
        pathList={files}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
      />,
      'md',
      false,
      true
    );
  };

  const handleAddNew = (row) => {
    AppCustomDialogHelper.show(
      !!row ? 'Cập nhật lô voucher' : 'Thêm lô voucher',
      <DialogVoucherBatchAddView
        item={row}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          getVoucherBatchDetail(voucherBatchId);
        }}
      />,
      'lg',
      false,
      true
    );
  };
  const handleCreateVoucher = (row) => {
    AppCustomDialogHelper.show(
      '',
      <DialogCreateVoucherView
        item={row}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          handleRefresh();
        }}
      />,
      'md',
      false,
      true
    );
  };

  const VoucherBatchInfo = () => {
    return (
      <div
        className={`w-100 m-0 position-relative p-3 bg-white rounded-lg`}
        style={{
          border: `1px solid ${AppColors.gray[300]}`,
          boxShadow: '0px 7px 8px -3px #0000000D',
        }}
      >
        <div className="d-flex px-0 align-items-center w-100">
          <div className="d-flex align-items-center w-95">
            <div className="d-flex flex-column ml-3 w-100">
              <div className="d-flex align-items-start gap-2" style={{ overflow: 'hidden' }}>
                <div
                  // className="font-weight-bolder text-ellipsis-2-lines"
                  style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}
                >
                  {voucherBatchDetail?.name}
                </div>

                <span className="min-w-100px pt-1">
                  <KTLabel
                    text={AgencyHelper.Utils.getVoucherBatchStatusName(voucherBatchDetail?.status)}
                    isInline={true}
                    size={KTLabelSize.medium}
                    additionalClassName={`label-light-${AgencyHelper.Utils.getVoucherBatchStatusColor(voucherBatchDetail?.status)}`}
                  />
                </span>
              </div>
            </div>
          </div>

          <div className="d-flex gap-3 justify-content-end ml-auto">
            <VITableRowDropDown
              toggleElement={
                <a
                  href="#"
                  className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                  style={{ backgroundColor: AppColors.gray[200] }}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <i
                    className="fa-solid fa-ellipsis"
                    style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                  />
                </a>
              }
              menuItem={[
                {
                  iconElement: (
                    <i
                      className="fa-regular fa-pen-to-square"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: 'Chỉnh sửa',
                  click: () => {
                    handleAddNew(voucherBatchDetail);
                  },
                  show: adminRole && voucherBatchDetail?.status === 'NEW',
                },
                {
                  iconElement: (
                    <i
                      className="fa-regular fa-ticket"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: 'Tạo voucher',
                  click: () => {
                    handleCreateVoucher(voucherBatchDetail);
                  },
                  show: adminRole && voucherBatchDetail?.status === 'NEW',
                },
                {
                  iconElement: (
                    <i
                      className="far fa-square"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: 'Ngừng hoạt động',
                  click: () => {
                    AgencyHelper.UI.showDialogConfirmStopVoucherBatch(voucherBatchDetail, () => {
                      getVoucherBatchDetail(voucherBatchId);
                    });
                  },
                  show: voucherBatchDetail?.status === 'ACTIVE',
                },
                {
                  iconElement: (
                    <i
                      className="far fa-play"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: 'Khôi phục hoạt động',
                  click: () => {
                    AgencyHelper.UI.showDialogConfirmActiveVoucherBatch(voucherBatchDetail, () => {
                      getVoucherBatchDetail(voucherBatchId);
                    });
                  },
                  show: voucherBatchDetail?.status === 'INACTIVE',
                },
                {
                  iconElement: (
                    <i
                      className={`fa-regular fa-trash-can`}
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: 'Xóa lô voucher',
                  click: () => {
                    AgencyHelper.UI.showDialogConfirmDeleteVoucherBatch(voucherBatchDetail, () => {
                      getVoucherBatchDetail(voucherBatchId);
                    });
                  },
                  show: adminRole && voucherBatchDetail?.status === 'NEW',
                },
              ]}
              singleBtnBgColor={AppColors.gray[200]}
            />
          </div>
        </div>

        <div
          className="my-4"
          style={{
            borderTop: `1px dashed ${AppColors.gray[300]}`,
          }}
        />

        {/* thong tin lo voucher */}
        <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
          <div className=" d-flex flex-lg-row flex-column flex-wrap">
            <>
              <div className="col-xl-6 p-0 pr-xl-3 pl-0 d-flex flex-column gap-3">
                {AgencyUIHelper.buildTableInfo(t('Thông tin cơ bản'), [
                  {
                    name: 'Tên đối tác',
                    value: voucherBatchDetail?.agency?.name,
                    color: AppColors.gray[800],
                  },
                  {
                    name: (
                      <div className="d-flex gap-2 align-items-center">
                        Hình thức phát hành

                        <KTTooltip
                          text={`<span>
                                Tự nhận: Khách hàng tự nhận voucher từ kho công khai<br />
                                Đối tác: Đối tác phân phối hoặc gán voucher cho khách hàng/xe<br />
                                Nội bộ: Nhà điều hành gán voucher trực tiếp, không công khai
                            </span>`}
                          textHeader="Hình thức phát hành"
                          isHtmlContent
                        >
                          <i className="fa-regular fa-info-circle" style={{ color: AppColors.info }} />
                        </KTTooltip>
                      </div>
                    ),
                    value: AgencyHelper.Utils.getVoucherBatchTypeName(voucherBatchDetail?.batchType),
                    color: AppColors.gray[800],
                  },
                  {
                    name: 'Đối tượng nhận voucher',
                    value: AgencyHelper.Utils.getVoucherIdentityTypeName(voucherBatchDetail?.identityType),
                    color: AppColors.gray[800],
                  },
                  {
                    name: 'Loại voucher',
                    value: AgencyHelper.Utils.getVoucherTypeName(voucherBatchDetail?.type),
                    color: AppColors.gray[800],
                  },
                  {
                    name: 'Giá trị voucher',
                    value: Utils.formatNumber(voucherBatchDetail?.value ?? 0),
                    color: AppColors.gray[800]
                  },
                  {
                    name: 'Người tạo',
                    value: voucherBatchDetail?.creator?.fullname,
                    color: AppColors.primary,
                    action: () => {
                      DealerHelper.navigateToParentAgency(voucherBatchDetail?.creator);
                    }
                  },
                  {
                    name: 'Ngày tạo',
                    value: Utils.formatDateTimeToString(voucherBatchDetail?.createdAt, 'DD/MM/YYYY - HH:mm'),
                  },
                  {
                    name: 'Tệp đính kèm',
                    value: voucherBatchDetail?.attachedFiles?.length > 0 ? `Xem chi tiết (${voucherBatchDetail?.attachedFiles?.length})` : '',
                    color: AppColors.primary,
                    action: () => {
                      handleViewFiles(voucherBatchDetail?.attachedFiles);
                    }
                  },
                ])}
              </div>

              <div className="col-xl-6 p-0 pl-0 d-flex flex-column gap-3 mt-4 mt-lg-0">
                {AgencyUIHelper.buildTableInfo(t('Thông tin chi tiết'), [
                  {
                    name: 'Số ngày hiệu lực từ lúc phát hành',
                    value: voucherBatchDetail?.duration,
                    color: AppColors.gray[800],
                  },
                  {
                    name: 'Hạn phát hành',
                    value: voucherBatchDetail?.expirationDate ? Utils.formatDateTimeToString(voucherBatchDetail?.expirationDate, 'DD/MM/YYYY') : '',
                    color: AppColors.gray[800],
                  },
                  {
                    name: 'Số lượng voucher đã mua',
                    value: voucherBatchDetail?.quantity,
                    color: AppColors.gray[800],
                  },
                  {
                    name: 'Số lượng voucher đã phát hành',
                    value: voucherBatchDetail?.usedQuantity,
                    color: AppColors.gray[800]
                  },
                  {
                    name: 'Số lượt tối đa sử dụng của mỗi voucher',
                    value: voucherBatchDetail?.useLimit,
                    color: AppColors.gray[800],
                  },
                  {
                    name: 'Tiền tố',
                    value: voucherBatchDetail?.useLimit,
                    color: AppColors.gray[800],
                  },
                ])}

                <div>
                  {UIHelper.buildSectionTitle('Mô tả')}
                  {UIHelper.buildSectionCard(
                    <div
                      className="px-3 py-2"
                      style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}
                    >
                      <ShowMoreText
                        lines={3}
                        more="Xem thêm"
                        less="Thu gọn"
                        className="text-break"
                        anchorClass="text-success font-size-normal font-weight-bolder cursor-pointer hover-opacity-60"
                        onClick={() => { }}
                        expanded={false}
                        truncatedEndingComponent={'... '}
                      >
                        {voucherBatchDetail?.description}
                      </ShowMoreText>
                    </div>
                  )}
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className={`m-4`}>
        {/* thong tin Doi tac */}
        <CustomCard
          showHeader={false}
          additionalClassName="rounded-lg overflow-hidden"
          bgTransparent={true}
          showBorder={false}
          body={
            <div className="d-xl-flex d-lg-flex">
              {/* thong tin Doi tac */}
              <VoucherBatchInfo />
            </div >
          }
        />

        {/* table */}
        <div className='mt-4'>
          <VoucherListView voucherBatchId={voucherBatchId} />
        </div>
      </div >
    </div >
  );
}

export default VoucherBatchDetailView;
